import React from "react";
import "./style.scss";

interface Props {
  textBoxLabel?: string;
  placeholder: string;
  isNumericInput?: boolean,
  handleChange: any;
  customClass?: string;
  parentClass: string; //e.g. w-[100%], it will be a tailwind class
  value: string | number;
  rows?: number;
  regexCheck: any;
  errorMessage?: string;
  isMandatory?: boolean;
  maxLength?: number;
  buttonConfig?: any;
  isDisabled?: boolean;
  iconClass?: string;
  showErrorBox?: boolean;
  isIconPositionRight?: boolean;
  handleFocusOut?: (e: any) => void
}

const CustomTextField = (props: Props) => {
  const {
    textBoxLabel,
    placeholder,
    handleChange,
    customClass = "",
    parentClass,
    value = "",
    rows = 1,
    regexCheck = "",
    errorMessage = "",
    isMandatory = false,
    maxLength = 10,
    buttonConfig = {},
    isDisabled = false,
    iconClass = "",
    showErrorBox = true,
    isIconPositionRight = false,
    handleFocusOut,
    isNumericInput,
  } = props;

  function getInputBoxBorderClass() {
    if (buttonConfig.left && buttonConfig.right)
      return "rounded-[0px] bg-[#fff] text-center";
    else if (buttonConfig.left) return "rounded-r-lg bg-[#fff] text-center";
    else if (buttonConfig.right) return "rounded-l-lg bg-[#fff] text-center";
    return "rounded-[8px] bg-[#fafafa]";
  }

  const handleInputValue = (e: any) => {
    if (regexCheck) {
      handleChange(regexCheck(e.target.value));
    } else {
      handleChange(e.target.value);
    }
  };

const commonProps = {
  className: `w-full ${iconClass ? (isIconPositionRight ? "pr-36" : "pl-36") : ""
    } ${getInputBoxBorderClass()} ${customClass} resize-none ${errorMessage ? "border-[#9A3131]" : "border-[#EBEBEB]"
    } border-[1px] py-12 overflow-hidden text-ellipsis whitespace-nowrap`,
  placeholder,
  onChange: (e: any) => handleInputValue(e),
  value: (value || value === 0) ? value : "",
  maxLength,
  onBlur: handleFocusOut,
};

const renderInputField = (commonProps: any) => {
  if (isNumericInput) {
    return <input type="tel" inputMode="numeric" pattern="[0-9]*" {...commonProps} />;
  }
  return <textarea name="Text1" rows={rows} {...commonProps}></textarea>;
};

  return (
    <section
      className={`${parentClass} ${isDisabled && "pointer-events-none"}`}
    >
      {textBoxLabel ? (
        <p className="mb-8 text-14 capitalize text-[#656565]">
          {textBoxLabel}{" "}
          {isMandatory && <span className="text-[#9A3131]">*</span>}
        </p>
      ) : null}
      <div className="flex">
        {buttonConfig.left ? (
          <button
            onClick={() => buttonConfig.left?.onClick && buttonConfig.left?.onClick()}
            className={`bg-[#fafafa] py-8 ${buttonConfig.left?.customClass} flex items-center justify-center rounded-l-lg border-y-[1px] border-l-[1px] border-[#EBEBEB] text-16`}
          >
            {buttonConfig.left?.textHtml ? "" : buttonConfig.left.text}
          </button>
        ) : null}
        <div className="flex relative grow">
          {(iconClass && !isIconPositionRight) ? (
            <div
              className={`rista-sprite ${iconClass} absolute top-1/2 left-[10px] -translate-y-1/2`}
            ></div>
          ) : null}

          {/* Renders an <input> with numeric keyboard support when isNumericInput is true, otherwise falls back to <textarea> */}
         {renderInputField(commonProps)}

          {(iconClass && isIconPositionRight) ? (
            <div
              className={`rista-sprite ${iconClass} absolute top-1/2 right-[10px] -translate-y-1/2`}
            ></div>
          ) : null}
        </div>
        {buttonConfig.right ? (
          <button
            onClick={() => buttonConfig.right?.onClick && buttonConfig.right?.onClick()}
            className={`bg-[#fafafa] py-8 ${buttonConfig.right?.customClass} flex items-center justify-center rounded-r-lg border-r-[1px] border-y-[1px] border-[#EBEBEB] text-16`}
          >
            {buttonConfig.right?.textHtml ? "" : buttonConfig.right.text}
          </button>
        ) : null}
      </div>

      {
        showErrorBox ?
          <p className="mt-4 text-12 font-normal text-[#9A3131] h-[18px]">
            {errorMessage ? errorMessage : ""}
          </p> : null
      }
    </section>
  );
};

export default CustomTextField;
